<template>
  <div>
    <vue-excel-xlsx
      :data="data"
      :columns="columns"
      :filename="'franquias'"
      :sheetname="'sheetname'"
      v-if="controlerBtnSubmit == true"
      class="btn btn-primary"
    >
      Franquias
    </vue-excel-xlsx>
    <button type="button" class="btn btn-primary" disabled v-else>
      <i class="fa fa-refresh fa-spin"></i> Carregando Franquias...
    </button>
  </div>
</template>

<script>
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
Vue.use(VueExcelXlsx);

export default {
  // lista de franquias passada pelo componente Index
  // variavel que irá armazenar os dados que serão exportados para planilha Excel
  data() {
    return {
      env: process.env,
      franquias: [],
      controlerBtnSubmit: false,
      // colunas para composição da planilha Excel
      columns: [
        {
          label: "Número franquia",
          field: "id",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Nome Solicitante",
          field: "usuario_nome",
        },
        {
          label: "Email Solicitante",
          field: "usuario_email",
        },
        {
          label: "Regional",
          field: "regional",
        },
        {
          label: "Estado",
          field: "uf",
        },
        {
          label: "Sigla",
          field: "sigla",
        },
        {
          label: "Sigla Operações",
          field: "sigla_operacao",
        },
        {
          label: "Endereço",
          field: "endereco",
        },
        {
          label: "Código do Imóvel",
          field: "codigo_imovel",
        },
        {
          label: "Serviço",
          field: "servico",
        },
        {
          label: "Fornecedor",
          field: "fornecedor",
        },
        {
          label: "Custo",
          field: "custo",
        },
        {
          label: "Proprietário",
          field: "proprietario",
        },
        {
          label: "Mês",
          field: "mes",
        },
        {
          label: "Ano",
          field: "ano",
        },
        {
          label: "Data de Execução",
          field: "data_execucao",
        },
        {
          label: "Data de Criação",
          field: "data",
        },
      ],
    };
  },
  watch: {
    // registros: function () {
    //   this.franquias = this.registros
    //   // console.warn(this.franquias)
    // },
    // função para atribuir os dados recebidos na variável franquias e formatá-los
    // franquias: function () {
    //   // console.log(this.franquias);
    //   this.formatarDados()
    // }
  },
  mounted: function () {
    this.planilhaFranquia();
  },
  methods: {
    planilhaFranquia() {
      let vm = this;

      this.$axios
        .get(`${this.env.FINANCEIRO.SLA}/getFranquias`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.login.loginUsuario.token}`,
          },
        })
        .then(function (response) {
          // sla = response.data
          vm.franquias = response.data;
          vm.data = response.data;
          vm.formatarDados();
          vm.controlerBtnSubmit = true;
        });
    },
    priceFormat(value) {
      return "R$ " + value;
    },
    // função para formatar os dados da lista de franquias e adcionálos ao array que irá preencher a planilha Excel
    formatarDados() {
      this.franquias.sort((a, b) => a.id - b.id);
      this.data = [];
      this.data = this.franquias.map((franquia) => {
        return {
          ...franquia,
          // data: this.formataDataBrasil(franquia.data),
          data_execucao:
            franquia.data_execucao == null
              ? ""
              : this.formataDataBrasil(franquia.data_execucao),
          data: franquia.data == null ? "" : this.formataDataBrasil(franquia.data),
          // data_execucao: this.formataDataBrasil(franquia.data_execucao),
          mes: this.formataMesPorExtenso(franquia.mes),
        };
      });
      // let counter = 0
      // let count = this.franquias.length
    },
    moeda: function (val) {
      if (val !== "" && val !== null) {
        let val2 = val.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
        val2 = val2.replace(".", ",");
        return val2;
      } else {
        return val;
      }
    },
    formataDataBrasil: function (dataForm) {
      if (dataForm !== "" && dataForm !== undefined && dataForm !== null) {
        let dataHoraAntigaSeparada = dataForm.split(" ");
        let dataSeparada = dataHoraAntigaSeparada[0].split("-");
        return `${dataSeparada[2]}/${dataSeparada[1]}/${dataSeparada[0]}`;
      }
      return dataForm;
    },
    formataMesPorExtenso: function (mes) {
      let mesesAno = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      return `${mesesAno[mes - 1]}`;
    },
  },
};
</script>

<style scoped>
button:hover {
  background-color: #6c757d;
}

/* button {
  background-color: #3c7fe4;
  color: white;
  margin: 1%;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 5px;
  padding-top: 5px;
  border-style: none;
  border-radius: 5px;
  width: 160px;
  height: 50px;
} */
</style>



// WEBPACK FOOTER //
// ExportFranquias.vue?637794d8